import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Dropdown = ({ selectedOption, options = [], onChange, innerLabel }) => {
  const getDisplayLabel = () => {
    if (selectedOption) {
      if (innerLabel) {
        return `${innerLabel} ${selectedOption.label.toLowerCase()}`;
      }
      return `${selectedOption.label}`;
    }
    return null;
  };

  const [selectLabel, setSelectLabel] = useState(getDisplayLabel());

  const handleOptionChange = e => {
    const option = options.find(el => el.value === e.target.value);
    onChange(option);
  };

  useEffect(() => {
    setSelectLabel(getDisplayLabel());
  }, [selectedOption]);

  return (
    <select
      onChange={handleOptionChange}
      value="placeholder"
      aria-label={getDisplayLabel()}
    >
      <option value="placeholder" hidden>
        {selectLabel}
      </option>
      {options.map((option, i) => (
        <option key={i} value={option.value}>
          {typeof option === 'object' ? option.label : option}
        </option>
      ))}
    </select>
  );
};

Dropdown.propTypes = {
  selectedOption: PropTypes.shape({
    value: PropTypes.PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]),
    label: PropTypes.string
  }),
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  innerLabel: PropTypes.string
};

export default Dropdown;
